export const initFocusScroll = () => {
  if (document.documentElement.dataset.peFocusScrollInit === "1") return;
  document.documentElement.dataset.peFocusScrollInit = "1";

  const focusableSelector = 'a, button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  let keyboardNavigation = false;

  document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      keyboardNavigation = true;
    }
  }, true);

  document.addEventListener("pointerdown", () => {
    keyboardNavigation = false;
  }, true);

  document.addEventListener("focusin", (event) => {
    if (!keyboardNavigation) return;
    if (!(event.target instanceof Element)) return;

    const target = event.target.closest(focusableSelector);
    if (!target) return;

    window.requestAnimationFrame(() => {
      const rect = target.getBoundingClientRect();
      const padding = 24;
      const isFullyVisible =
        rect.top >= padding &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight - padding &&
        rect.right <= window.innerWidth;

      if (isFullyVisible) return;

      target.scrollIntoView({
        block: "center",
        inline: "nearest",
      });
    });
  }, true);
};
